import { Module } from "vuex";
import { RootState } from "../types";
import { UserProfile } from "./types";
import { getters } from "./getter";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state = {
  error: "",
  data: [],
} as UserProfile;

export const profile: Module<UserProfile, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
